module.exports = __webpack_public_path__ + "img/1.13d79127.jpg";